'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultInfuraProjectId = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _ethers = require('ethers');

var _colonyJsAdapterEthers = require('@colony/colony-js-adapter-ethers');

var _colonyJsAdapterEthers2 = _interopRequireDefault(_colonyJsAdapterEthers);

var _colonyJsContractLoaderNetwork = require('@colony/colony-js-contract-loader-network');

var _colonyJsContractLoaderNetwork2 = _interopRequireDefault(_colonyJsContractLoaderNetwork);

var _colonyJsContractLoaderHttp = require('@colony/colony-js-contract-loader-http');

var _index = require('./ColonyNetworkClient/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('./lib/EthersWrappedWallet/index');

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultInfuraProjectId = exports.defaultInfuraProjectId = '7d0d81d0919f4f05b9ab6634be01ee73';

// Adapted from Ethers 4.0 to include support for Goerli

/* eslint-disable import/no-cycle */

var getInfuraProvider = function getInfuraProvider(network, infuraProjectId) {
  var host = void 0;
  switch (network) {
    case 'homestead':
    case 'mainnet':
      host = 'mainnet.infura.io';
      break;
    case 'goerli':
      host = 'goerli.infura.io';
      break;
    default:
      throw new Error('Could not get provider, unsupported network: ' + network);
  }

  return new _ethers.providers.JsonRpcProvider('https://' + host + '/v3/' + (infuraProjectId || defaultInfuraProjectId), network === 'goerli' ? {
    chainId: 5,
    ensAddress: '0x112234455c3a32fd11230c42e7bccd4a84e02010',
    name: 'goerli'
  } : network);
};

// This method provides a simple way of getting an initialized network client
// that uses NetworkLoader for the remote network and TrufflePigLoader for a
// local testrpc network (TrufflePig must be installed and running).
var getNetworkClient = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(network, wallet, infuraProjectId) {
    var loader, provider, ethersWallet, adapter, networkClient;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loader = void 0;
            provider = void 0;

            // Set loader and provider

            if (network === 'local') {
              loader = new _colonyJsContractLoaderHttp.TrufflepigLoader();

              // Throw custom error if TrufflePig is not installed and running
              loader.getAccounts().catch(function () {
                throw new Error('Make sure you have TrufflePig installed and running.');
              });

              provider = new _ethers.providers.JsonRpcProvider();
            } else {
              loader = new _colonyJsContractLoaderNetwork2.default({ network: network });
              provider = getInfuraProvider(network, infuraProjectId);
            }

            // Use EthersWrappedWallet if purser wallet
            ethersWallet = wallet.type && wallet.subtype ? new _index4.default(wallet, provider) : wallet;

            // Initialize adpaters using ethers

            adapter = new _colonyJsAdapterEthers2.default({
              loader: loader,
              provider: provider,
              // $FlowFixMe colonyJS types don't yet accept some methods as async
              wallet: ethersWallet
            });

            // Initialize network client using ethers adapter and default query

            networkClient = new _index2.default({ adapter: adapter, query: {} });
            _context.next = 8;
            return networkClient.init();

          case 8:
            return _context.abrupt('return', networkClient);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getNetworkClient(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = getNetworkClient;
//# sourceMappingURL=getNetworkClient.js.map